import { authAxios } from "@/api";
import axios from "axios";
import { API_VER, ROOT_URL } from "@/setup/constants"

const API_CONTROLLER = "ward";

export class WardApi {
    static getWardList(wardId, filterInfo){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/contacts`;
        return authAxios.post(url, filterInfo);
    }

    static getWard(wardId){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/detail`;
        return authAxios.get(url);
    }

    static getWardPublic(wardId, securityKey) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/public/detail/${securityKey}`;
      // Use regular axios for public endpoints (no auth required)
      return axios.get(url);
    }

    static getWardOrganizations(wardId){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/organizations`;
        return authAxios.get(url);
    }

    static searchWardOrganizations(wardId, pagingInfo){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/organizations`;
        return authAxios.post(url, pagingInfo);
    }

    static getWardOrganization(wardId, orgCode){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/organization/${orgCode}`;
        return authAxios.get(url);
    }

    static getWardAccountBalance(wardId) {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/account-balance`;
        return authAxios.get(url)
    }

    static updateWardOrganization(wardId, orgCode, orgInfo){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/organization/${orgCode}`;
        return authAxios.put(url, orgInfo);
    }

    static createWardOrganization(wardId, orgInfo) {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/organization/create`;
        return authAxios.post(url, orgInfo);
    }

    static getWardDetail(wardId){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/detail`;
        return authAxios.get(url);
    }

    static updateWard(wardId, wardInfo){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/detail`;
        return authAxios.put(url, wardInfo);
    }

    static getWardContact(wardId, contactId){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/contact/${contactId}`;
        return authAxios.get(url);
    }

    static filterWardOrganization(wardId, filterInfo){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/contacts/org`;
        return authAxios.post(url,filterInfo);
    }

    static updateWardContact(wardId, contactId, contactInfo){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/contact/${contactId}`;
        return authAxios.put(url, contactInfo);
    }

    static createWardContact(wardId, contactInfo){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/contact/create`;
        return authAxios.post(url, contactInfo);
    }

    static createPublicWardContact(wardId, contactInfo) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/contact/public/create`;
      return authAxios.post(url, contactInfo);
    }

    static deleteWardContact(wardId, contactId){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/contact/${contactId}`;
        return authAxios.delete(url);
    }

    static searchContactNotes(wardId, contactId, PagingInfo){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/contact/${contactId}/notes`;
        return authAxios.post(url, PagingInfo);
    }

    static createContactNote(wardId, contactId, NoteInfo) {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/contact/${contactId}/create-note`;
        return authAxios.post(url, NoteInfo);

    }

    static sendNotificationText(wardId, notificationMessage){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/message/create`;
        return authAxios.post(url, notificationMessage);
    }

    static uploadContactSpreadsheet(wardId, bulkContactUpload){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/contact-import`;
        return authAxios.post(url, bulkContactUpload);
    }

    static searchImportRequests(wardId, PagingInfo) {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/contact-import-list`;
        return authAxios.post(url, PagingInfo);
    }

    static searchImportRequestsContacts(wardId, importRequestId, PagingInfo) {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/bulk-contact-list/${importRequestId}`;
        return authAxios.post(url, PagingInfo);
    }

    static getImportRequest(wardId, importRequestId)
    {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/contact-import/${importRequestId}`;
        return authAxios.get(url);
    }

    static performImportRequest(wardId, importRequestId)
    {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/perform-import/${importRequestId}`;
        return authAxios.get(url);
    }

    static performingBulkSmsRequest(wardId, importRequestId)
    {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/contact-import-consent/${importRequestId}`;
        return authAxios.get(url);
    }

    static fetchCarriers(wardId)
    {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/contact-carrier-fetch`;
        return authAxios.get(url);
    }

    static getWardUserDetail(wardId, username){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/${username}`;
        return authAxios.get(url);
    }

    static updateWardUserDetail(wardId, username, userData){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/${username}`;
        return authAxios.put(url, userData);
    }

    static getWardFrontEndSettings(wardId) {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/front-end-settings`;
        return authAxios.get(url);
    }

    static getWardPublicQrCode(wardId) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/public/qrcode`;
      return authAxios.get(url)
    }

    static getWardPublicAppointmentQrCode(wardId) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/public/appointment/qrcode`;
      return authAxios.get(url)
    }

    static getWardTwilioProfiles(wardId) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/customer-profiles`
      return authAxios.get(url)
    }

    static deleteWardTwilioProfile(wardId, profileSid) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/customer-profiles/${profileSid}`
      return authAxios.delete(url)
    }

    static getWardTwilioAddresses(wardId) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/addresses`
      return authAxios.get(url)
    }

    static getWardTwilioAddress(wardId, addressSid) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/addresses/${addressSid}`
      return authAxios.get(url)
    }

    static createWardTwilioStarterProfile(wardId, profileData) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/customer-profiles/starter`
      return authAxios.post(url, profileData)
    }

    static runWardTwilioEvaluation(wardId, profileSid) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/customer-profiles/${profileSid}/evaluation`
      return authAxios.post(url)
    }

    static getWardTwilioProfileEvaluations(wardId, profileSid, limit = 20) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/customer-profiles/${profileSid}/evaluations?limit=${limit}`
      return authAxios.get(url)
    }

    static submitWardTwilioProfile(wardId, profileSid) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/customer-profiles/${profileSid}/submit`
      return authAxios.post(url)
    }

    static getWardTwilioServices(wardId) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/messaging-services`
      return authAxios.get(url)
    }

    static getWardTwilioServiceDetail(wardId, serviceSid) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/messaging-services/${serviceSid}`
      return authAxios.get(url)
    }

    static createWardTwilioService(wardId, serviceData) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/messaging-services`
      return authAxios.post(url, serviceData)
    }

    static getWardTwilioPhoneNumbers(wardId) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/phone-numbers`
      return authAxios.get(url)
    }

    static updateWardTwilioPhoneNumber(wardId, phoneSid, phoneData) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/phone-numbers/${phoneSid}`
      return authAxios.put(url, phoneData)
    }

    static searchAvailablePhoneNumbers(wardId, searchParams) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/phone-numbers/available`
      return authAxios.get(url, { params: searchParams })
    }

    static purchasePhoneNumber(wardId, purchaseData) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/phone-numbers/purchase`
      return authAxios.post(url, purchaseData)
    }

    static getServicePhoneNumbers(wardId, serviceSid) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/messaging-services/${serviceSid}/phone-numbers`
      return authAxios.get(url)
    }

    static addPhoneNumberToService(wardId, serviceSid, phoneNumberSid) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/messaging-services/${serviceSid}/phone-numbers`
      return authAxios.post(url, { phone_number_sid: phoneNumberSid })
    }

    static removePhoneNumberFromService(wardId, serviceSid, phoneNumberSid) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/messaging-services/${serviceSid}/phone-numbers/${phoneNumberSid}`
      return authAxios.delete(url)
    }

    static getWardTwilioCampaigns(wardId) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/campaigns`
      return authAxios.get(url)
    }

    static getWardTwilioCampaignDetail(wardId, campaignSid) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/campaigns/${campaignSid}`
      return authAxios.get(url)
    }

    static createWardTwilioSoleProprietorshipCampaign(wardId, campaignData) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/campaigns/sole-proprietorship`
      return authAxios.post(url, campaignData)
    }

    static deleteWardTwilioCampaign(wardId, campaignSid) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/campaigns/${campaignSid}`
      return authAxios.delete(url)
    }

    static resubmitWardTwilioCampaign(wardId, campaignSid) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/campaigns/${campaignSid}/resubmit`
      return authAxios.post(url)
    }

    static getServiceCampaigns(wardId, serviceSid) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/messaging-services/${serviceSid}/campaigns`
      return authAxios.get(url)
    }

    static getWardTwilioBrandRegistrations(wardId) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/brand-registrations`
      return authAxios.get(url)
    }

    static getWardTwilioBrandCampaigns(wardId, brandSid) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/brand-registrations/${brandSid}/campaigns`
      return authAxios.get(url)
    }

    static createWardTwilioBrandRegistration(wardId, brandData) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/brand-registrations`
      return authAxios.post(url, brandData)
    }

    static createWardTwilioUsa2p(wardId, serviceSid, usa2pData) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/messaging-services/${serviceSid}/compliance/usa2p`
      return authAxios.post(url, usa2pData)
    }

    static getWardTwilioUsa2pResources(wardId, serviceSid) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/messaging-services/${serviceSid}/compliance/usa2p`
      return authAxios.get(url)
    }

    static getWardTwilioUsa2pResource(wardId, serviceSid, usa2pSid) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/messaging-services/${serviceSid}/compliance/usa2p/${usa2pSid}`
      return authAxios.get(url)
    }

    static deleteWardTwilioUsa2pResource(wardId, serviceSid, usa2pSid) {
      const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/twilio/messaging-services/${serviceSid}/compliance/usa2p/${usa2pSid}`
      return authAxios.delete(url)
    }

}
